module.exports = __webpack_public_path__ + "static/img/强沙尘暴.748962a3.svg";